<script lang="ts" setup>
import { computed } from 'vue'

import { getGridEntries } from './utils'

import type { BaseFieldClass } from '@/models/fields/baseField.class'
import type { IGridGroup } from '@/types/serverGrid.type'

const props = defineProps<{
  fields: BaseFieldClass[]
  groups?: IGridGroup[]
}>()

const entries = computed(() => getGridEntries(props.fields, props.groups))
</script>

<template>
  <template
    v-for="entry in entries"
    :key="entry.key"
  >
    <div
      v-if="entry.group"
      class="layout-grid__group"
      :style="{
        gridArea: entry.area,
        flexDirection: entry.group.direction ?? 'row',
        alignItems: entry.group.direction === 'column' ? 'start' : 'end',
        gap: entry.group.gap ?? '8px',
        flexWrap: entry.group.wrap ? 'wrap' : 'nowrap'
      }"
    >
      <slot
        v-for="field in entry.fields"
        :key="field.name"
        :field="field"
      />
    </div>
    <slot
      v-else
      :field="entry.fields[0]!"
    />
  </template>
</template>

<style lang="scss" scoped>
.layout-grid__group {
  display: flex;
  min-width: 0;

  > :deep(.layout-grid__item) {
    flex: 0 1 auto;
  }
}
</style>
